<!--Start Content Container-->

<!-- Page 1: First Page Header (Full Page with Project and Building Characteristics) -->
<app-print-first-page-header *ngIf="printData"
                             [printData]="printData"
                             [calculationName]="calculationName"
                             [projectCharacteristics]="projectCharacteristics"
                             [isExistingBuildingCal]="isExistingBuildingCal"
                             [parameterGroupsCache]="parameterGroupsCache"
                             [selectedsubmenu]="selectedsubmenu"
                             [levensduurHuidig]="levensduurHuidig"
                             [resterendLevensduurHuidig]="resterendLevensduurHuidig"
                             [levensduurIngreep]="levensduurIngreep"
                             [resterendLevensduurIngreep]="resterendLevensduurIngreep">
</app-print-first-page-header>


<!-- Page 2: Combination Building details based on condition-->
<app-print-combination-building-details *ngIf="isShowCombinationBuildingFeature && combinationBuildingDetails as details "
                                        class="print-page landscape"
                                        [details]="details"
                                        [selectedDataSet]="selectedDataSet"
                                        [isCombinationBuildingSelected]="isCombinationBuildingSelected">
</app-print-combination-building-details>



<!-- Page 2: MPG summary (charts, scores, environmental categories) -->
<div class="landscape-wrapper" *ngIf="selectedsubmenu=='all' || selectedsubmenu=='mpg' ">
  <app-print-mpg-landscape [calculationResults]="calculationResults"
                           [calculationResultsAfter]="calculationResultsAfter"
                           [mpgResultTitle]="mpgResultTitle"
                           [isExistingBuildingCal]="isExistingBuildingCal"
                           [selectedDataSet]="selectedDataSet"
                           [mpgResultTitlePerMainElementTitle]="mpgResultTitlePerMainElementTitle"
                           [printData]="printData"
                           [envirnmentalCategoryTitle]="envirnmentalCategoryTitle"
                           [environmentEffects]="environmentEffects"
                           [environmentEffectsAfter]="environmentEffectsAfter"
                           [chartOption]="chartOption"
                           [currentMainElements]="currentMainElements"
                           [afterMainElements]="afterMainElements"
                           [codes]="codes"
                           [tableColumns]="tableColumns"
                           [elementResultTitle]="elementResultTitle"></app-print-mpg-landscape>
</div>

<!-- Page 3+: MPG per element details -->
<div class="landscape-wrapper" *ngIf="selectedsubmenu === 'all' || selectedsubmenu === 'mpg'|| selectedsubmenu === 'materialpassport' ">
  <app-print-mpg-elements-landscape [elementResultTitle]="elementResultTitle"
                                    [calculationResults]="calculationResults"
                                    [calculationResultsAfter]="calculationResultsAfter"
                                    [isExistingBuildingCal]="isExistingBuildingCal"
                                    [selectedDataSet]="selectedDataSet"
                                    [mpgResultTitlePerMainElementTitle]="mpgResultTitlePerMainElementTitle"
                                    [printData]="printData"
                                    [envirnmentalCategoryTitle]="envirnmentalCategoryTitle"
                                    [environmentEffects]="environmentEffects"
                                    [environmentEffectsAfter]="environmentEffectsAfter"
                                    [selectedsubmenu]="selectedsubmenu"></app-print-mpg-elements-landscape>
</div>

<!-- Extra Indicators landscape page -->
<div class="landscape-wrapper"
     *ngIf="(selectedsubmenu === 'all' || selectedsubmenu === 'extraindicators' || selectedsubmenu === 'materialpassport')
            && !isExistingBuildingCal ">
    <app-print-extra-indicator-landscape [qciResultsDto]="nmdCalculationResponseDto_ForExtraIndicator?.qciResults"
                                         [hnnResultsDto]="nmdCalculationResponseDto_ForExtraIndicator?.hnnResults"
                                         [csrdResultsDto]="nmdCalculationResponseDto_ForExtraIndicator?.csrdResults"
                                         [wlcResultsDto]="nmdCalculationResponseDto_ForExtraIndicator?.wlcResults"
                                         [mpg]="nmdCalculationResponseDto_ForExtraIndicator?.mpg"
                                         [parisProofIndicator]="nmdCalculationResponseDto_ForExtraIndicator?.parisProofIndicator"
                                         [selectedDataSet]="selectedDataSet"
                                         [totalUsedProducts]="nmdCalculationResponseDto_ForExtraIndicator?.totalUsedProducts"
                                         [constructionStoredCarbon]="nmdCalculationResponseDto_ForExtraIndicator?.constructionStoredCarbon"
                                         [selectedsubmenu]="selectedsubmenu">

    </app-print-extra-indicator-landscape>
</div>

<!-- Fixed footer for print: logo + full-bleed footer image -->
<div class="container footer" aria-hidden="true">
  <div class="footer-inner">
    <div class="footer-left">
      <i class="gpr-logo" aria-hidden="true"></i>
      <div class="brand-text footer-brand-text">{{ 'PRINT_PAGE.MATERIAL' | translate }}</div>
    </div>
  </div>

  <img src="/assets/img/gpr_materiaal-footer.png" class="img-fluid footer-bar" alt="footer graphic" />
</div>

